import { Component, ContentChild, DoCheck, Input, OnDestroy, OnInit, TemplateRef, } from '@angular/core';
import { MenuItem } from './../../../base/models/menu-items'

@Component({
  selector: 'app-hierarchical-menu',
  templateUrl: './hierarchical-menu.component.html',
  styleUrls: ['./hierarchical-menu.component.scss']
})

export class HierarchicalMenuComponent implements DoCheck, OnInit, OnDestroy {
  @Input() ids: Array<any> = []
  @Input() activeChain: string[] = []
  @Input() menuData: Object
  @Input() isChild = false
  @Input() type = 'default'
  @Input() showArrows = true
  @Input() first = false

  @ContentChild(TemplateRef) templateRef: TemplateRef<any>

  currentLevelList = []

  ngDoCheck() {
    this.updateIds();
  }

  ngOnInit() {
  }

  ngOnDestroy() {}

  isParentTopMenu(menuItem: MenuItem): boolean {
    let parent: MenuItem = this.menuData[menuItem.parent]

    if (parent) {
      return parent.type.toLowerCase() === 'top'
    }

    return false
  }

  updateIds() {
    this.currentLevelList = [];
    if (this.ids && Array.isArray(this.ids))
    this.ids.forEach((code) => {
      if ((this.isChild || !this.menuData[code].parent || this.isParentTopMenu(this.menuData[code]))) {
          this.currentLevelList.push(code);
        }
      });
  }
}
